import styled from "styled-components";

export const StyledList = styled.ul`
  margin-top: 30px;
  padding: 0;
  list-style: none;
  li {
    font-family: Inter;
    font-size: ${({ theme }) => theme.fontSize.m};
    font-style: normal;
    font-weight: 400;
    line-height: 30px;
    color: ${({ theme }) => theme.colors.dark};
  }
`;
